<div class="main">
  <div class="row">
    <div class="container">
      <div class="sponsorsList">
        <img class="victoryRoad" src={{victoryroad}} alt="Logo VictoryRoad" />
      </div>
    </div>
  </div>
</div>
